import { ReactNode } from 'react';
import { DownloadPDFWrapperProps } from '@msc-b2c/interfaces/types';
import { DownloadPDF } from './DownloadPDF';

export function DownloadPDFWrapper(props: Readonly<DownloadPDFWrapperProps>): ReactNode {
  return <DownloadPDF {...props} />;
}

export default DownloadPDFWrapper;

DownloadPDFWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/downloadpdf';
